import React from 'react'

const CassetteTape: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/cassette_tape.svg" alt="cassette_tape"/>
  )
}

export default CassetteTape